export default "__VITE_PUBLIC_ASSET__03d3b7d6__"